// Define o título original
let originalTitle = document.title;
let cartTitle = "Items in Cart 🍱 | Complete Your Order 🚀";
let flashSaleTitle = "Flash Sale! ⏰ | Grab the Discount!";
let personalizedTitle = userName ? `Come back, ${userName}! 🥗 | Your Order Awaits!` : "Come back! 🥗 | Your Order Awaits!";
let timeout;

// Função para verificar itens no carrinho usando AJAX
function checkCartItems() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      if (cart.items.length > 0) {
        startTitleAnimation(cartTitle);
      }
    })
    .catch(error => console.error('Error fetching cart:', error));
}

// Função para verificar se há uma promoção relâmpago ativa (personalizar conforme necessário)
function flashSaleActive() {
  // Customizar com lógica de promoção ativa
  return false; // Ajuste de acordo com a configuração de promoção
}

// Inicia a animação do título com a mensagem fornecida
function startTitleAnimation(message) {
  timeout = setInterval(() => {
    document.title = document.title === originalTitle ? message : originalTitle;
  }, 1500);
}

// Para a animação do título
function stopTitleAnimation() {
  clearInterval(timeout);
  document.title = originalTitle;
}

// Detecta a mudança de visibilidade da aba
document.addEventListener("visibilitychange", function() {
  if (document.hidden) {
    if (flashSaleActive()) {
      // Se houver promoção relâmpago ativa
      startTitleAnimation(flashSaleTitle);
    } else {
      // Verifica itens no carrinho
      checkCartItems();
    }
  } else {
    stopTitleAnimation();
  }
});
